import IconRadioGroup from './IconRadioGroup';

export default IconRadioGroup;
